import React from 'react'

class Contact extends React.Component {
  render() {
    return (
      <div className="content-container" id="contact">
        <div className="content-title">お問い合わせ</div>
        <div className="contact-tel">
          <label>ＴＥＬ</label>
          <span>（０４２２）５５－１２０３</span>
        </div>
      </div>
    )
  }
}

export default Contact

